import clsx from "clsx";
import t from "../locales";

export function Progress({
  children,
  disablePrevious,
  onPreviousPage,
  disableNext,
  onNextPage,
  showNext = true,
}) {
  return (
    <>
      <div className="page__progress-container">
        <div className="page__progress">
          <button
            className={clsx(
              "button button--icon button--transparent",
              disablePrevious && "button--transparent-disabled",
            )}
            onClick={(e) => {
              e.preventDefault();
              onPreviousPage();
            }}
            disabled={disablePrevious}
            aria-label={t("progress.previous")}
            type="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="23"
              viewBox="0 0 12 13"
              fill="currentColor"
              className="button__icon"
            >
              <path d="M3.04271 5.83317L11.6667 5.83317L11.6667 7.24984L3.04271 7.24984L7.00937 11.2165L6 12.2082L0.333333 6.54151L6 0.874838L7.00937 1.8665L3.04271 5.83317Z" />
            </svg>
          </button>
          {children}
          {showNext && (
            <button
              className="button button--icon button--transparent"
              onClick={(e) => {
                e.preventDefault();
                onNextPage(e);
              }}
              disabled={disableNext}
              aria-label={t("progress.next")}
              type="submit"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="23"
                viewBox="0 0 12 13"
                fill="currentcolor"
                className="button__icon"
                style={{ transform: "rotate(180deg)" }}
              >
                <path d="M3.04271 5.83317L11.6667 5.83317L11.6667 7.24984L3.04271 7.24984L7.00937 11.2165L6 12.2082L0.333333 6.54151L6 0.874838L7.00937 1.8665L3.04271 5.83317Z" />
              </svg>
            </button>
          )}
        </div>
        <span className="page__progress-text">{t("progress.description")}</span>
      </div>
    </>
  );
}
